function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
import EventTarget from '../event-target';
var TrackList = function (_EventTarget) {
    _inherits(TrackList, _EventTarget);
    function TrackList() {
        var _this;
        var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _classCallCheck(this, TrackList);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(TrackList).call(this));
        _this.tracks_ = [];
        Object.defineProperty(_assertThisInitialized(_this), 'length', {
            get: function get() {
                return this.tracks_.length;
            }
        });
        for (var i = 0; i < tracks.length; i++) {
            _this.addTrack(tracks[i]);
        }
        return _this;
    }
    _createClass(TrackList, [
        {
            key: 'addTrack',
            value: function addTrack(track) {
                var index = this.tracks_.length;
                if (!('' + index in this)) {
                    Object.defineProperty(this, index, {
                        get: function get() {
                            return this.tracks_[index];
                        }
                    });
                }
                if (this.tracks_.indexOf(track) === -1) {
                    this.tracks_.push(track);
                    this.trigger({
                        track: track,
                        type: 'addtrack'
                    });
                }
            }
        },
        {
            key: 'removeTrack',
            value: function removeTrack(rtrack) {
                var track;
                for (var i = 0, l = this.length; i < l; i++) {
                    if (this[i] === rtrack) {
                        track = this[i];
                        if (track.off) {
                            track.off();
                        }
                        this.tracks_.splice(i, 1);
                        break;
                    }
                }
                if (!track) {
                    return;
                }
                this.trigger({
                    track: track,
                    type: 'removetrack'
                });
            }
        },
        {
            key: 'getTrackById',
            value: function getTrackById(id) {
                var result = null;
                for (var i = 0, l = this.length; i < l; i++) {
                    var track = this[i];
                    if (track.id === id) {
                        result = track;
                        break;
                    }
                }
                return result;
            }
        }
    ]);
    return TrackList;
}(EventTarget);
TrackList.prototype.allowedEvents_ = {
    change: 'change',
    addtrack: 'addtrack',
    removetrack: 'removetrack'
};
for (var event in TrackList.prototype.allowedEvents_) {
    TrackList.prototype['on' + event] = null;
}
export default TrackList;